import * as IconSelector from '../icons';

export const tiposApunte = [
    {
        value: 'Apertura',
        label: 'Apertura',
        description: 'Apertura Contable',
        icon: IconSelector.PointIcon,
        color: 'Green',
        contabilidad: true,
        entrada: false
    },
    {
        value: 'Regularizacion',
        label: 'Regularizacion',
        description: 'Regularización Contable',
        icon: IconSelector.PointIcon,
        color: 'Orange',
        contabilidad: true,
        entrada: false
    },
    {
        value: 'Cierre',
        label: 'Cierre',
        description: 'Cierre Contable',
        icon: IconSelector.PointIcon,
        color: 'Red',
        contabilidad: true,
        entrada: false
    },
    {
        value: 'Gasto',
        label: 'Gasto',
        description: 'Gasto',
        icon: IconSelector.GastosIcon,
        color: 'Red',
        entrada: false
    },
    {
        value: 'Compra',
        label: 'Compra',
        description: 'Compra',
        icon: IconSelector.PointIcon,
        color: 'Orange',
        entrada: false
    },
    {
        value: 'Nomina',
        label: 'Nomina',
        description: 'Nomina',
        icon: IconSelector.PointIcon,
        color: 'Blue',
        entrada: false
    },
    {
        value: 'Liquidacion',
        label: 'Liquidación',
        description: 'Liquidación',
        icon: IconSelector.LiquidacionesIcon,
        color: 'Green',
        entrada: true
    },
    {
        value: 'Tesoreria',
        label: 'Tesorería',
        description: 'Cobros, pagos, remesas',
        icon: IconSelector.CobrosPagosIcon,
        color: 'Black',
        entrada: true
    }
];
